import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import logger from './utils/logger';

function PrivateRoute({ children }) {
  const authToken = localStorage.getItem('authToken');

  if (!authToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default PrivateRoute;
